import AchievementsDataset from "../datasets/achievements_dataset";
import determineCelebrationText from "../../../objects/CommonUse/determine_celebration_text";
import determineCreditScore from "../objectsEndOfTurn/determine_credit_score";
import determineAchievementStatus from "../objectsStatus/determine_achievement_status";

export const determineAchievementDisplayInfo = (achievementId, achievementSlctd, creditCardInfo,
        gameData, totalGameMonths, investmentActive, timeWizardInfo, savingsInfo,
        summaryInvestment, investmentMaster, moneyMgmtTestArr) => {
    const achievementInfo = AchievementsDataset.find(elem => elem.achievementID === achievementId);
    const achievementType = "trophy";
    const achievementName = achievementInfo.achievementName;
    const achievementTitle = achievementInfo.achievementTitle;
    let additionalText = "";
    let achievementDesc = "";
    let statusObj = {};
    if (achievementSlctd.earned === true){
        const medalType = achievementSlctd.medalType;
        additionalText = determineCelebrationText(medalType, achievementId);
    }else{
        achievementDesc = achievementInfo.unearnedAchievementDesc;
        let creditCardBalance = "";
        let creditCardActive = false;
        if (creditCardInfo.currentlyActive){
            if (creditCardInfo.currentlyActive === true){
                // using previous period for outstanding credit card balance because
                // it accounts for manual payments and excludes cases where the
                // player is checking 'mid-turn'.
                creditCardActive = true;
                creditCardBalance = creditCardInfo.prevPeriodOutstandBalance;
            }else{
                creditCardBalance = "N/A";
            }
        }
        const creditScore = determineCreditScore(creditCardInfo, gameData.loanTable,
            gameData.currentGameDate, gameData.gameNbrMonths, timeWizardInfo ).creditScore;
        const nbrMonthsPlayed = +totalGameMonths - +gameData.gameNbrMonths;
        statusObj = determineAchievementStatus(achievementSlctd.id, 
            gameData, savingsInfo, creditCardActive, creditCardBalance, investmentActive, 
            summaryInvestment, investmentMaster, nbrMonthsPlayed, creditScore, 
            gameData.unlockedFeatures, gameData.achievementArr, moneyMgmtTestArr
        );
    }
    const returnObj = {achievementType: achievementType, achievementName: achievementName, 
        achievementTitle: achievementTitle, additionalText: additionalText, achievementDesc: achievementDesc,
        statusTextArr: statusObj.textArr, link: statusObj.linkName, linkText: statusObj.linkText, 
        earnedText: statusObj.earnedText
    }
    return returnObj;
}
export default determineAchievementDisplayInfo;